export const KEYS = {
	COOKIE_TOKEN_ID: 'f_a_token',
	EXPIRE_TOKEN: 'f_e_token',
	EXPIRES_IN: 2 /**Days**/,
	STORAGE_TOKEN_ID: 'f_s_token',
	AUTH_TOKEN: 'auth-token',
	COOKIE_SERVICE_URL: 's_url',
	STORAGE_SERVICE_URL_ID: 's_url',
};
